var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-chart-donut',{attrs:{"data":_vm.data,"colors":_vm.colors}})
}
var staticRenderFns = []

export { render, staticRenderFns }